import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IDmEmailConfigActionTypes } from "../../action-types/email/IDmEmailConfigActionTypes";
import { IDmEmailConfigReducer } from "../../page-state-model/email/IDmEmailConfigReducer";
const iniState: IDmEmailConfigReducer = {
    status: ePageBaseStatus.is_not_initialization,
    emailConfigs: []
}
export const dmEmailConfigReducer = (state: IDmEmailConfigReducer = iniState, action: IDmEmailConfigActionTypes): IDmEmailConfigReducer => {
    switch (action.type) {
        case "EMAIL_CONFIG_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "EMAIL_CONFIG_LOAD_SUCCCES":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                emailConfigs: action.payload
            }
        case "EMAIL_CONFIG_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                emailConfigs: []
            }
        case "EMAIL_CONFIG_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "EMAIL_CONFIG_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "EMAIL_CONFIG_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "EMAIL_CONFIG_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "EMAIL_CONFIG_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "EMAIL_CONFIG_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "EMAIL_CONFIG_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "EMAIL_CONFIG_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}